import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
const ShareIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(SvgIcon, { fontSize: "inherit", ...props, ref, viewBox: "-0.5 -0.5 17 17", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M5.36 4.54568L7.2 2.70338V10.393C7.2 10.8736 7.52 11.194 8 11.194C8.48 11.194 8.8 10.8736 8.8 10.393V2.70338L10.64 4.54568C10.96 4.86608 11.44 4.86608 11.76 4.54568C12.08 4.22528 12.08 3.74468 11.76 3.42428L8.56 0.220275C8.48 0.140175 8.4 0.0600751 8.32 0.0600751C8.16 -0.020025 7.92 -0.020025 7.68 0.0600751C7.6 0.0600751 7.52 0.140175 7.44 0.220275L4.24 3.42428C3.92 3.74468 3.92 4.22528 4.24 4.54568C4.56 4.86608 5.04 4.86608 5.36 4.54568ZM15.2 9.59199C14.72 9.59199 14.4 9.91239 14.4 10.393V13.597C14.4 14.0776 14.08 14.398 13.6 14.398H2.4C1.92 14.398 1.6 14.0776 1.6 13.597V10.393C1.6 9.91239 1.28 9.59199 0.8 9.59199C0.32 9.59199 0 9.91239 0 10.393V13.597C0 14.9587 1.04 16 2.4 16H13.6C14.96 16 16 14.9587 16 13.597V10.393C16 9.91239 15.68 9.59199 15.2 9.59199Z",
      fill: "currentColor"
    }
  ) });
});
ShareIcon.displayName = "ShareIcon";
export {
  ShareIcon
};
//# sourceMappingURL=ShareIcon.js.map
